import { useMemo } from "react";

import { swSettings } from "app/common/services/swSettings";
import { getAccessibleQuickSearchCatalogPages } from "app/components/React/QuickSearch/pageData/getAccessibleQuickSearchCatalogPages";
import {
    getQuickSearchCatalogPages,
    type QuickSearchCatalogPage,
} from "app/components/React/QuickSearch/pageData/getQuickSearchCatalogPages";
import { getSidebarAccessMap } from "app/components/React/QuickSearch/pageData/getSidebarAccessMap";

export const useAccessibleQuickSearchCatalogPages = (locale?: string): QuickSearchCatalogPage[] => {
    const userId = swSettings?.user?.id;
    return useMemo(
        () => getAccessibleQuickSearchCatalogPages(getQuickSearchCatalogPages(locale ?? "en"), getSidebarAccessMap()),
        [locale, userId],
    );
};
